<template>
    <!-- <a v-bind:href="path" :target="destination"> -->
    <div v-if="shouldRender" class="w-full">
        <button class="w-full focus:outline-none" v-if="action" v-on:click="executeAction">
            <div class="h-12 flex flex-row items-center flex-grow-0 flex-shrink-0 text-theme-copy3
                        hover:bg-theme-menuhoverbg hover:text-theme-menuhovertext transition-colors duration-100">
                <i v-if="circledicon" class="material-icons ml-2 mr-2 pl-2 pt-2 cursor-pointer w-10 h-10 icon-circled">{{ iconName }}</i>
                <i v-else class="material-icons ml-2 mr-2 pl-2 pt-2 cursor-pointer w-10 h-10">{{ iconName }}</i>
                <span v-if="this.$root.shared.sidebar_visible"><slot name="label"></slot></span>
            </div>
        </button>
        <button class="w-full focus:outline-none" v-if="vuelink" v-on:click="vuenavigate(vuelink)">
            <div class="h-12 flex flex-row items-center flex-grow-0 flex-shrink-0 text-theme-copy3
                        hover:bg-theme-menuhoverbg hover:text-theme-menuhovertext transition-colors duration-100"
                        :class="{ 'bg-theme-menuhoverbg': isActive }">
                <i v-if="circledicon" class="material-icons ml-2 mr-2 pl-2 pt-2 cursor-pointer w-10 h-10 icon-circled">{{ iconName }}</i>
                <i v-else class="material-icons ml-2 mr-2 pl-2 pt-2 cursor-pointer w-10 h-10">{{ iconName }}</i>
                <span v-if="this.$root.shared.sidebar_visible"><slot name="label"></slot></span>
            </div>
        </button>
        <button class="w-full focus:outline-none" v-if="path" v-on:click="navigateToPath">
            <div class="h-12 flex flex-row items-center flex-grow-0 flex-shrink-0 text-theme-copy3
                            hover:bg-theme-menuhoverbg hover:text-theme-menuhovertext transition-colors duration-100"
                            >
                <i v-if="circledicon" class="material-icons ml-2 mr-2 pl-2 pt-2 cursor-pointer w-10 h-10 icon-circled">{{ iconName }}</i>
                <i v-else class="material-icons ml-2 mr-2 pl-2 pt-2 cursor-pointer w-10 h-10">{{ iconName }}</i>
                <span v-if="this.$root.shared.sidebar_visible"><slot name="label"></slot></span>
                <i v-if="destination === '_blank'" class="material-icons cursor-pointer ml-auto mr-4 pt-1 icon-xs">open_in_new</i>
            </div>
        </button>

        <!-- DIVIDER -->
        <div v-if="divider" class="w-full">
            <div class="border-t border-theme-level2"></div>
        </div>


        <!-- SUBTITLE -->
        <div v-if="subtitle">
            <span v-if="this.$root.shared.sidebar_visible" class="ml-12 mt-8 mb-4 text-theme-discrete font-bold">{{ subtitle }}</span>
        </div>

    </div>
    <!-- </a> -->
</template>

<script>

    import { isMobileOnly } from 'mobile-device-detect';
    import { isTablet } from 'mobile-device-detect';

    export default {

        data() {
            return {
                smartphone: isMobileOnly,
                tabletDevice: isTablet
            }
        },

        computed: {

            shouldRender() {
                if(this.desktoponly) {
                    if(this.smartphone || this.tabletDevice) {
                        return false
                    } else {
                        return true
                    }
                } else {
                    return true
                }
            }

        },

        props: {
            divider: false,
            subtitle: '',
            path: String,
            destination: String,
            circledicon: {
                type: Boolean,
                default: false
            },
            'icon-name': String,
            action: String,
            vuelink: String,
            scope: String,
            desktoponly: false,
            language: ''
        },

        mounted() {
            /*console.log('SidebarItem component mounted.')*/
        },

        methods: {
            tryThis() {
                alert('Action worked');
            },

            closeTheSidebar() {
                this.$root.shared.sidebar_visible = false;
                this.$root.getSidebarClasses = false;
                this.$root.getContentClasses = false;
            },

            executeAction() {
                /*console.log('Executing action: ' + this.action + ' with Scope=' + this.scope);*/
                if(this.scope !== 'global') {
                    this[this.action]();
                }
                if(this.action === 'toggleTheme') {
                    Event.fire('toggleTheme');
                }
                if(this.action === 'showHistory') {
                    window.location = '/' + this.language + '/history';
                }
                if(this.action === 'showWatchLater') {
                    let userId = window.Laravel.user.id
                    this.$root.shared.playerPayload = ''
                    Event.fire('showPlaylistsView', { language: this.language, data: { userId: userId, isWatchLater: true } });
                }
                if(this.action === 'showPlaylists') {
                    let userId = window.Laravel.user.id
                    this.$root.shared.playerPayload = ''
                    this.$root.shared.preselectedPlaylist = { id: 1, name: 'default' }
                    Event.fire('showPlaylistsView', { language: this.language, data: { userId: userId, isWatchLater: false } });
                }
                if(this.$root.shared._isMobileOnly) {
                    /*console.log('An ACTION button was pressed on a mobile device, so the SideBar should be HIDING now.');*/
                    this.closeTheSidebar();
                }
            },

            navigateToPath() {
                if(this.destination === '_blank') {
                    window.open(this.path);
                } else {
                    window.location.href = this.path;
                }
                if(this.$root.shared._isMobileOnly) {
                    /*console.log('An ACTION button was pressed on a mobile device, so the SideBar should be HIDING now.');*/
                    this.closeTheSidebar();
                }
            },

            vuenavigate(route) {
                this.$router.push(route);
                this.$router.go(0);
                if(this.$root.shared._isMobileOnly) {
                    /*console.log('An ACTION button was pressed on a mobile device, so the SideBar should be HIDING now.');*/
                    this.closeTheSidebar();
                }
            }
        }
    }
</script>
